export default __webpack_public_path__ + "locales/fr/Notifications.json?hash=501a6d5aec0638da31a2dc0f33f18a51";